import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import type { BufferedChangeset } from 'ember-changeset/types'
import type ProgressHandlerService from 'teacher-ui-client/services/progress-handler'
import type { ProgressionRecord } from 'teacher-ui-client/progress-handler/utils'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { EditProgressSelect } from 'teacher-ui-client/components/form/edit-progress/select'

interface Args {
  progressChangeset: BufferedChangeset
  /**
   * An array of progression items from student-progress service for a student
   */
  studentProgression?: ProgressionRecord[]
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
  Blocks: {
    default: []
  }
}

export class EditProgressWritingLegends extends Component<Signature> {
  themeKey = ThemeKeys.darkBlue

  @service progressHandler!: ProgressHandlerService

  <template>
    <div class="grid grid-cols-[33%_66%] items-baseline justify-between gap-y-3" ...attributes>
      <label for={{this.progressHandler.writingLegendsWritingHandler.progressType}}>
        {{t "manage.manageProgress.editProgress.writingLegends.lessons"}}
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.writingLegendsWritingHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
    </div>
  </template>
}

export default EditProgressWritingLegends
